import { Component, OnInit } from '@angular/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { AssetStatusDto } from '@cradua/data';

@Component({
  selector: 'cradua-assetstatus-container',
  templateUrl: './assetstatus-container.component.html',
  styleUrls: ['./assetstatus-container.component.scss']
})
export class AssetstatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  assetStatuss$: Observable<AssetStatusDto[]>;
  loading: boolean;
  isLoadingAssetStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingAssetStatus$ = this.gatwayFacade.isLoadingGateway("AssetStatus");
    this.assetStatuss$ = this.gatwayFacade.loadGateway("AssetStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAssetStatus(deletedValue: any) {
    this.gatwayFacade.remove("AssetStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitAssetStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.AssetStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllBank = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllBank.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllBank.length > 0) {
    this.gatwayFacade.add('AssetStatus', addAllBank);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('AssetStatus', allUpdates, ['id']);
  }

   }

}
